<template>
  <div class="bg-red-50 border border-red-200 rounded-lg p-6 text-center">
    <div class="text-red-600 text-lg font-medium mb-2">Analysis Failed</div>
    <p class="text-red-700">{{ error }}</p>
    <button
      @click="$emit('retry')"
      class="mt-4 px-6 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors"
    >
      Try Again
    </button>
  </div>
</template>

<script>
export default {
  name: 'ErrorState',
  props: {
    error: String
  }
};
</script>
